import { useGroupManager } from "../../../hooks/useGroupManager";

export default function GroupPicker() {
  const { groups, setSelectedGroup } = useGroupManager();
  function handleChange(newValue) {
    setSelectedGroup(newValue);
  }
  return (
    <div className=" sticky top-1  w-full p-1 bg-primary-blue">
      <label htmlFor="selectGroup" className="sr-only">
        Sélectionner un Groupe :
      </label>
      <select
        id="selectGroup"
        className="border border-black w-full p-1 sm:text-xs md:text-sm lg:text-base z-0"
        onChange={(e) => handleChange(e.target.value)}
        defaultValue={""}
      >
        <option value="" key={0} disabled>
          --Sélectionner un Groupe--
        </option>
        {groups &&
          Object.keys(groups).map((groupName, index) => (
            <option value={groups[groupName].id} key={index}>
              {groupName}
            </option>
          ))}
      </select>
    </div>
  );
}
